import { styled } from '@mui/material/styles';

const getDisplayValue = (val?: boolean) => {
  return val ? 'none' : null;
};

interface StyledFormItemProps {
  hidden?: boolean;
  flexDirection?: 'row' | 'column';
  gap?: string;
  flexGrow?: number;
  width?: string;
  marginBottom?: string;
}

const StyledFormItem = styled('div')<StyledFormItemProps>`
  display: ${({ hidden }) => getDisplayValue(hidden) || 'flex'};
  flex-direction: ${({ flexDirection }) => flexDirection || 'column'};
  justify-content: center;
  gap: ${({ gap }) => gap || '0'};
  margin-top: 20px;
  margin-bottom: ${({ marginBottom }) => marginBottom || '20px'};
  position: relative;
  flex-grow: ${({ flexGrow }) => flexGrow || 0};
  width: ${({ width }) => width || '100%'};

  label {
    margin-bottom: 10px;
    display: inline-block;
  }

  small.info-text {
    color: var(--step-description-color);
  }
`;
export default StyledFormItem;
